import { LiveMapDisplayModeEnum, LiveMapRideFilterEnum } from "../enums";

export const DEFAULT_LIVE_MAP_HOURS_BACK = 2;
export const DEFAULT_LIVE_MAP_HOURS_FORWARD = 1;
export const DEFAULT_LIVE_MAP_GRID_REFRESH_INTERVAL_SEC = 10;
export const DEFAULT_LIVE_MAP_MAP_REFRESH_INTERVAL_SEC = 10;

/** Map poll RxJS timer starts after this fraction of the active map interval (desync from grid poll). */
export const LIVE_MAP_MAP_POLL_PHASE_OFFSET_RATIO = 0.5;

/** Minimum grid/map session polling interval (seconds); user may increase from this value. */
export const MIN_LIVE_MAP_REFRESH_INTERVAL_SEC = 10;

/** Default live map display when system param is unset (full display). */
export const DEFAULT_LIVE_MAP_DISPLAY_MODE = LiveMapDisplayModeEnum.stationPins;

/** Live-map toolbar / admin dropdown order (simple first, then full). */
export const LIVE_MAP_UI_DISPLAY_MODES = [
  LiveMapDisplayModeEnum.noDrivePath,
  LiveMapDisplayModeEnum.stationPins,
] as const;

/** Default ride-filter when session override is unset (matches legacy hide-untracked checkbox). */
export const DEFAULT_LIVE_MAP_RIDE_FILTER =
  LiveMapRideFilterEnum.hideNotTracked;

/** Live-map grid toolbar ride-filter popover order. */
export const LIVE_MAP_UI_RIDE_FILTERS = [
  LiveMapRideFilterEnum.all,
  LiveMapRideFilterEnum.hideNotTracked,
  LiveMapRideFilterEnum.hideFuturePastNotTracked,
] as const;

/** Radius (px) for station dots in simple live-map display mode. */
export const LIVE_MAP_STATION_DOT_RADIUS = 5;

/** Max rides selectable on live map grid/map at once (single, group, or select-all). */
export const LIVE_MAP_MAX_SELECTED_RIDES = 800;

/** In live-map debug mode, course rides alternate with / without synthetic client code. */
export const LIVE_MAP_DEBUG_COURSE_WITH_CODE_EVERY_N = 2;

/** Upper bound (km/h) for the randomized speed assigned to debug-mode tracking points. */
export const LIVE_MAP_DEBUG_TRACKING_MAX_SPEED_KMH = 90;

/** Synthetic course codes for debug map markers (3+ chars so marker label is meaningful). */
export const LIVE_MAP_DEBUG_COURSE_CODES: readonly string[] = [
  "701",
  "702",
  "703",
  "704",
  "705",
  "706",
];

export const LIVE_MAP_DEBUG_DRIVER_NAMES: readonly string[] = [
  "Ali Hasan",
  "Yossi Cohen",
  "Samah Sasha",
  "David Levi",
];

export const LIVE_MAP_DEBUG_PASSENGERS_COUNT_MAX = 40;
